module.exports = __webpack_public_path__ + "static/media/Illus-EmployeeBag@2x.26c8331e.png";